import React, { useState, Fragment, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Row,
  Col,
  Spinner,
  Button,
  Modal,
  Form,
  Table,
  InputGroup,
  Container,
} from "react-bootstrap";
import { useCookies } from "react-cookie";
import {
  getOrganizations,
  createOrganizatio,
  createSingleOrganization,
  getFeatures,
  updateOrganizationInfo,
  fetchOrganizationDetails,
  fetchUserManagementAPI,
} from "ServerAPI/serverAPI";
import CommonHeader from "layouts/dashboard/CommonHeader";
import courseIcon from "../../assets/images/Courses.svg";
import { useNavigate } from "react-router-dom";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TanstackTable from "../../components/elements/advance-table/TanstackTable.js";
import actionIcon from "../../components/organisation/action-icon.svg";
import { useCallback } from "react";
import Select from "react-select";
import CommonDialog from "components/Dialog/CommonDialog";
import UpdateOrganization from "./UpdateOrganization";
import { useToast } from "context/toast-context/ToastProvider";
import EditIcon from "@mui/icons-material/Edit";
import { useLoader } from "components/loader/GlobalLoader";
import FormSelect from "components/elements/form-select/FormSelect";
// import GlobalLoader from "components/loader/GlobalLoader";

const OrganizationDetails = () => {
  const [cookies] = useCookies();
  const [loading, setLoading] = useState(true);
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const navigate = useNavigate();
  const [isOrganizationUpdating, setIsOrganizationUpdating] = useState(false);
  const [openGlobalLOader, setOpenGlobalLOader] = useState(false);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewOrgModal, setShowViewOrgModal] = useState(false);
  const [organizationDetails, setOrganizationDetails] = useState({});
  const [availableFeatures, setAvailableFeatures] = useState([]);
  const [userManagements, setUserManagements] = useState([]);
  const { showToast } = useToast();
  const { showLoader, hideLoader } = useLoader();

  const [openUpdateOrganizationDIalog, setOpenUpdateOrganizationDIalog] =
    useState(false);
  const [organizationData, setOrganizationData] = useState({});
  const [updatedFeatures, setUpdatedFeatures] = useState([]);
  const [updatedUserManagement, setUpdatedUserManagement] = useState([]);

  useEffect(() => {
    console.log("organizationDetails____", organizationDetails);

    setOrganizationData(() => {
      return {
        name: organizationDetails?.name,
        address: organizationDetails?.address,
        phoneNumber: organizationDetails?.phoneNumber,
        email: organizationDetails?.email,
        userManagement: organizationDetails?.userManagement,
        genAIModel: organizationDetails?.genAIModel,
        storage: organizationDetails?.totalStorage,
        totalUsers: organizationDetails?.totalUsers,
        imagesBucket: organizationDetails?.s3Details?.videosBucket,
        mainBucket: organizationDetails?.s3Details?.mainBucket,
      };
    });
  }, [organizationDetails]);

  const [formData, setFormData] = useState({
    organizationName: "",
    companyEmail: "",
    companyAddress: "",
    contactNumber: "",
    totalUsers: "",
    totalStorage: "",
    // userManagement: "",
    genAIModel: "",
    preEnrolledCourses: [],
    features: [],
    totalUsers: organizationDetails?.totalStorage,
    userManagement: {},
    mainBucket: "",
    imagesBucket: "",
  });

  const resetForm = useCallback(() => {
    setFormData({
      organizationName: "",
      companyEmail: "",
      companyAddress: "",
      contactNumber: "",
      totalUsers: "",
      totalStorage: "",
      userManagement: {},
      genAIModel: "",
      preEnrolledCourses: [],
      features: [],
    });
  }, []);

  // Handle other input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCreateOrganization = async () => {
    try {
      setIsLoading(true);

      const body = {
        email: cookies.email,
        roleId: cookies.roleId,
        organizationName: formData.organizationName,
        companyEmail: formData.companyEmail,
        companyAddress: formData.companyAddress,
        contactNumber: formData.contactNumber,
        totalUsers: parseInt(formData.totalUsers, 10) || 0,
        totalStorage: parseInt(formData.totalStorage, 10) || 0,
        userManagement: formData.userManagement?.value,
        genAIModel: formData.genAIModel,
        featureIds: formData.features,
        mainBucket: formData.mainBucket,
        imagesBucket: formData.videosBucket,
      };

      const response = await createSingleOrganization(body);

      if (response.status === 200 || response.status === 201) {
        const newOrg = response.data;
        fetchOrganizations();
        handleCloseCreateModal();
        resetForm();
        showToast("Organization created successfully!", "success");
      } else {
        const errorMsg = response?.data?.message || "Failed to create organization.";
        console.error("❌ API Error:", errorMsg);
        showToast(errorMsg, "error");
      }
    } catch (error) {
      console.error("❌ Exception during organization creation:", error);
      const errMsg = error?.response?.data?.message || "An error occurred while creating the organization.";
      showToast(errMsg, "error");
    } finally {
      setIsLoading(false);
    }
  };


  const fetchOrganizations = async () => {
    try {
      setLoading(true);
      const response = await getOrganizations(cookies.email, cookies.roleId);
      const orgs = response.data.organizations || [];
      console.log("✅ Fetching Updated Organizations:", response);

      const formattedData = orgs.map((org, index) => ({
        id: index + 1,
        organizationId: org.organizationId || "N/A",
        name: org.organizationName || org.name || "Unknown",
        domain: Array.isArray(org.domain)
          ? org.domain.join(", ")
          : org.domain || "N/A",
        address: org.companyAddress || org.address || "N/A",
        phoneNumber: org.contactNumber || org.phoneNumber || "N/A",
        coordinator: org.organizationCoordinator?.name || "Not Assigned",
        totalStorage: org.totalStorage || "N/A",
        totalUsers: org.totalUsers || "N/A",
        userManagement: org.userManagement || "N/A",
        genAIModel: org.genAIModel || "N/A",
        email: org.email,
      }));

      setOrganizations(formattedData);
    } catch (error) {
      console.error("❌ Error fetching organizations:", error);
      setOrganizations([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Call fetchOrganizations when the component mounts
  useEffect(() => {
    fetchOrganizations();
  }, [cookies.email, cookies.roleId]);

  // Show modals
  const handleShowCreateModal = useCallback(() => {
    setShowCreateModal(true);
  }, []);
  const handleCloseCreateModal = useCallback(() => {
    setShowCreateModal(false);
  }, []);

  // Fetch features on component mount
  const fetchFeatures = async () => {
    try {
      // TODO: Uncomment when API is working

      const response = await getFeatures(cookies?.roleId);
      const featureOptions = response.data.features.map((f) => ({
        value: f.featureId,
        label: f.featureName,
      }));
      setAvailableFeatures(featureOptions);
    } catch (error) {
      console.error("Error fetching features:", error);
    }
  };

  const fetchUserManagement = async () => {
    try {
      const response = await fetchUserManagementAPI({
        email: cookies?.email,
        roleId: cookies?.roleId
      });

      const userManagementOptions = response.data.userManagement.map((um) => ({
        value: um.userManagementId,
        label: um.name,
      }));

      setUserManagements(userManagementOptions);
    } catch (error) {
      console.error("Error fetching user management:", error);
      // Handle error appropriately
    }
  };

  useEffect(() => {
    if (showCreateModal) {
      fetchFeatures();
      fetchUserManagement();
    }
  }, [showCreateModal]);

  const handleViewOrganization = (organization) => {
    console.log("🚀 Navigating with Organization Data:", organization);

    navigate("/view-organization-details", {
      state: { organization },
    });
  };

  const handleCloseViewOrgModal = () => {
    setSelectedOrganization(null);
    setShowViewOrgModal(false);
  };

  const columns = [
    {
      header: <span style={{ color: "#224B99", fontWeight: "bold" }}>SN</span>,
      accessorKey: "id",
      cell: (info) => info.row.index + 1,
      headerStyle: {
        backgroundColor: "rgba(34, 75, 153, 0.1)",
        color: "#224B99",
        fontWeight: "bold",
      },
    },
    {
      header: (
        <span style={{ color: "#224B99", fontWeight: "bold" }}>
          Organization Name
        </span>
      ),
      accessorKey: "name",
      headerStyle: {
        backgroundColor: "rgba(34, 75, 153, 0.1)",
        color: "#224B99",
        fontWeight: "bold",
      },
    },
    {
      header: (
        <span style={{ color: "#224B99", fontWeight: "bold" }}>Users</span>
      ),
      accessorKey: "totalUsers",
      headerStyle: {
        backgroundColor: "rgba(34, 75, 153, 0.1)",
        color: "#224B99",
        fontWeight: "bold",
      },
    },
    {
      header: (
        <span style={{ color: "#224B99", fontWeight: "bold" }}>
          Total Storage (GB)
        </span>
      ),
      accessorKey: "totalStorage",
      cell: (info) => info.getValue() || "N/A",
      headerStyle: {
        backgroundColor: "rgba(34, 75, 153, 0.1)",
        color: "#224B99",
        fontWeight: "bold",
      },
    },
    {
      header: (
        <span style={{ color: "#224B99", fontWeight: "bold" }}>Actions</span>
      ),
      accessorKey: "actions",
      cell: ({ row }) => (
        <>
          <div className="d-flex align-items-center">
            <button
              onClick={() => handleViewOrganization(row.original)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "5px",
              }}
            >
              <img
                src={actionIcon} // ✅ Use imported SVG file
                alt="View"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <div
              onClick={() => {
                updateOrganization(row.original);
              }}
              className="cursor-pointer"
            >
              <EditIcon />
            </div>
          </div>
        </>
      ),
    },
  ];

  const updateOrganization = async (data) => {
    showLoader();

    const payload = {
      organizationId: data?.organizationId,
    };

    try {
      const response = await fetchOrganizationDetails(data?.organizationId);

      if (response.status === 200) {
        fetchFeatures();
        fetchUserManagement();
        setUpdatedFeatures(
          response?.data?.features.map((feature) => ({
            value: feature?.featureId,
            label: feature?.featureName,
          }))
        );
        setOrganizationDetails(response?.data);
        setOpenUpdateOrganizationDIalog(true);
      } else {
        const errorMsg = response?.data?.message || "Something went wrong, try again later.";
        showToast(errorMsg, "error");
      }
    } catch (error) {
      console.error("❌ Error fetching organization details:", error);
      const errMsg = error?.response?.data?.message || "An error occurred while updating the organization.";
      showToast(errMsg, "error");
    } finally {
      hideLoader();
    }
  };

  const handleDialogCLose = () => {
    setOpenUpdateOrganizationDIalog(false);
  };

  const handleSaveOperation = async () => {
    console.log("organizationData", organizationData);

    const payload = {
      name: organizationData?.name,
      address: organizationData?.address,
      PhoneNumber: organizationData?.phoneNumber,
      organizationId: organizationDetails?.organizationId,
      authorUserId: cookies?.userId,
      // email: organizationData?.email,
      totalStorage: organizationData?.storage,
      totalUsers: organizationData?.totalUsers,
      genAIModel: organizationData?.genAIModel,
      userManagement: organizationData?.userManagement,
      featureIds: updatedFeatures?.map((feature) => {
        return feature?.value;
      }),
      mainBucket: organizationData?.mainBucket,
      imagesBucket: organizationData?.videosBucket,
    };
    setIsOrganizationUpdating(true);
    const response = await updateOrganizationInfo("", payload);
    if (response?.status === 200) {
      fetchOrganizations();
      showToast("Organization Updated successfully", "success");
      handleDialogCLose();
      setIsOrganizationUpdating(false);
    } else {
      showToast("Organization update failed", "error");
    }
  };

  return (
    <Fragment>
      <CommonHeader
        text="Organizations"
        subText="Manage organizations here."
        icon={courseIcon}
      />

      {/* Space above the table */}
      <div style={{ marginTop: "20px" }}></div>

      {/* ✅ Wrapped in Container for styling */}
      <Container style={styles.container}>
        {/* Heading */}
        <h3 style={styles.heading}>Organization Database</h3>

        {/* Search & Add Organization in the Same Row */}
        <Row className="mb-3 align-items-center">
          <Col md={8} className="d-flex">
            <InputGroup style={{ maxWidth: "300px" }}>
              <Form.Control
                type="text"
                placeholder="Search Organization"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col md={4} className="text-end">
            <Button variant="primary" size="sm" onClick={handleShowCreateModal}>
              + Add
            </Button>
          </Col>
        </Row>

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "200px" }}
          >
            <Spinner animation="border" size="lg" />
          </div>
        ) : (
          <TanstackTable
            data={organizations.filter((org) =>
              (org.name || "").toLowerCase().includes(searchTerm.toLowerCase())
            )}
            columns={columns}
            filter={false}
            pagination={true}
          />
        )}

      </Container>

      {/* Create Organization Modal */}
      <Modal
        show={showCreateModal}
        onHide={handleCloseCreateModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="border-bottom-0 pb-0">
          <Modal.Title className="text-lg font-semibold">
            Add Organization Data
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <Form>
            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Organization Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="organizationName"
                    placeholder="Enter organization name"
                    value={formData.organizationName}
                    onChange={handleInputChange}
                    required
                    disabled={isLoading}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Company Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="companyEmail"
                    placeholder="Enter company email"
                    value={formData.companyEmail}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Company Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="companyAddress"
                    placeholder="Enter company address"
                    value={formData.companyAddress}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Contact Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="contactNumber"
                    placeholder="Enter contact number"
                    value={formData.contactNumber}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Users</Form.Label>
                  <Form.Control
                    type="number"
                    name="totalUsers"
                    placeholder="Enter Users"
                    value={formData.totalUsers}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Storage</Form.Label>
                  <Form.Control
                    type="number"
                    name="totalStorage"
                    placeholder="Enter Storage"
                    value={formData.totalStorage}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Main Bucket</Form.Label>
                  <Form.Control
                    type="text"
                    name="mainBucket"
                    placeholder="Enter Main Bucket Name"
                    value={formData.mainBucket}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Videos Bucket</Form.Label>
                  <Form.Control
                    type="text"
                    name="videosBucket"
                    placeholder="Enter Videos Bucket Name"
                    value={formData.videosBucket}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              {/* User Management */}
              <Col>
                <Form.Group>
                  <Form.Label>User Management</Form.Label>
                  <Select
                    name="userManagement"
                    options={userManagements}
                    value={formData.userManagement}
                    placeholder="Choose your user management"
                    onChange={(selectedOption) => {
                      setFormData((prev) => ({
                        ...prev,
                        userManagement: selectedOption,
                      }));
                    }}
                  />
                </Form.Group>
              </Col>

              {/* Gen AI Model */}
              <Col>
                <Form.Group>
                  <Form.Label>Gen AI Model</Form.Label>
                  <Select
                    name="genAIModel"
                    options={[
                      { value: "ChatGPT", label: "ChatGPT" },
                      { value: "Ollama", label: "Ollama" },
                      { value: "DeepSeek", label: "DeepSeek" },
                    ]}
                    value={
                      formData.genAIModel
                        ? { value: formData.genAIModel, label: formData.genAIModel }
                        : null
                    }
                    placeholder="Select Gen AI Model"
                    onChange={(selectedOption) => {
                      setFormData((prev) => ({
                        ...prev,
                        genAIModel: selectedOption?.value || "",
                      }));
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* New Features Multi-Select Dropdown */}
            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Features</Form.Label>
                  <Select
                    isMulti
                    name="features"
                    options={availableFeatures}
                    value={availableFeatures.filter((opt) =>
                      formData.features.includes(opt.value)
                    )}
                    onChange={(selectedOptions) => {
                      setFormData((prev) => ({
                        ...prev,
                        features: selectedOptions.map((opt) => opt.value),
                      }));
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer className="border-top-0">
          <div className="d-flex justify-content-end">
            <Button
              variant="outline-secondary"
              onClick={handleCloseCreateModal}
              className="me-2"
              style={{
                border: "2px solid #6c757d",
                padding: "8px 24px",
                borderRadius: "5px",
                fontWeight: "bold",
                backgroundColor: "white",
                color: "#6c757d",
              }}
              disabled={isLoading}
            >
              Cancel
            </Button>
            {isLoading ? (
              <>
                <CircularProgress />
              </>
            ) : (
              <>
                <Button
                  onClick={handleCreateOrganization}
                  className="px-4"
                  style={{
                    backgroundColor: "#224B99",
                    border: "2px solid #224B99",
                    padding: "8px 24px",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Add
                </Button>
              </>
            )}
          </div>
        </Modal.Footer>
      </Modal>

      {/* ✅ FIXED: View Organization Modal */}
      <Modal show={showViewOrgModal} onHide={handleCloseViewOrgModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Organization Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOrganization && (
            <div>
              <p>
                <strong>Name:</strong> {selectedOrganization.name}
              </p>
              <p>
                <strong>Domain:</strong> {selectedOrganization.domain}
              </p>
              <p>
                <strong>Address:</strong> {selectedOrganization.address}
              </p>
              <p>
                <strong>Phone Number:</strong>{" "}
                {selectedOrganization.phoneNumber}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseViewOrgModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* update organization MOdal */}
      <CommonDialog
        open={openUpdateOrganizationDIalog}
        handleDialogCLose={handleDialogCLose}
        handleSaveOperation={handleSaveOperation}
        content={
          <UpdateOrganization
            organizationData={organizationData}
            userManagements={userManagements}
            setOrganizationData={setOrganizationData}
            availableFeatures={availableFeatures}
            setUpdatedFeatures={setUpdatedFeatures}
            updatedFeatures={updatedFeatures}
          />
        }
        isSaveBtnLoading={isOrganizationUpdating}
        headerText="Update Organization"
      />
      {/* <GlobalLoader open={openGlobalLOader} /> */}
    </Fragment>
  );
};

const styles = {
  container: {
    backgroundColor: "#f8f9fa", // Mild grey background
    padding: "20px",
    borderRadius: "12px", // Curved border
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    marginTop: "20px",
    color: "#224B99",
  },
  heading: {
    fontSize: "22px",
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "20px",
    color: "#224B99",
  },
  addButton: {
    backgroundColor: "#000000",
    border: "none",
  },
};

export default OrganizationDetails;
